import { useEffect, useState } from 'react';

import useApi from 'Lib/hooks/useApi';
import SelectFilter from 'Lib/muiComponents/common/SelectFilter';

export default function UserStatic(props) {
    const fetchUsers = useApi(props.api.getUsers);
    const [options, setOptions] = useState(null);

    const getOptions = () => {
        fetchUsers({ currentUserFirst: true, includeUnassignedUser: true }).then(response => {
            const options = response.data.map(({ user }) => ({
                label: `${user.firstName} ${user.lastName}`,
                value: user.userID
            }));
            setOptions(options);
        });
    };

    const UserSelect = () => {
        return (
            <SelectFilter
                multi={props.multi}
                value={props.value}
                label={props.label}
                placeholder={!options ? 'Loading...' : 'Type to search user'}
                options={options || []}
                onChange={(__, options) => props.onChange(props.name, options)}
            />
        );
    };

    useEffect(() => {
        getOptions();
    }, []);

    return <UserSelect />;
}
